import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export interface EDRRoundelText {
	heading: string;
	subText: string;
}

@Component({
	standalone: true,
	selector: 'edr-roundel',
	templateUrl: './roundel.component.html',
	styleUrls: ['./roundel.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EDRRoundelComponent {
	@Input() public roundelText?: EDRRoundelText;
	@Input() public imagePath = '/assets/images/everyday-rewards/rocket-outlined.svg';
}
